<template>
  <div>
    <!--    //Exercise-->
    <exercice-display v-if="text.exercice" :exercice="text.exercice"/>
    <!--    //Core-->
    <b-card no-body>
      <b-card-header header-bg-variant="primary" header-text-variant="white" class="text-center exercice-toggle">
        <b>Texte Audio:</b>
      </b-card-header>
      <b-card-body class="d-flex justify-content-center">
        <audio v-if="audio" controls>
          <source :src="getURL()">
        </audio>
        <b-btn v-if="audio && !text.fini" variant="danger" @click="removeAudio">Supprimer</b-btn>
        <div v-else-if="true">
          Pour cet exercice audio, vous devez vous enregistrer et envoyer le fichier audio via e-mail à : laurent.lucquet16@gmail.com
        </div>
        <audio-record v-else-if="!audio" pause @audio="onAudio"/>
      </b-card-body>
    </b-card>
    <!--    // Correction-->
    <b-card no-body v-if="text.fini && (isTeacher() || text.corrige)">
      <b-card-header header-bg-variant="primary" header-text-variant="white" class="text-center exercice-toggle">
        <b>Correction:</b>
      </b-card-header>
      <b-card-body class="d-flex justify-content-center">
        <audio v-if="correction.audio" controls>
          <source :src="getCorrectionURL()">
        </audio>
        <b-btn v-if="correction.audio && !text.corrige" variant="danger" @click="removeCorrectionAudio">Supprimer
        </b-btn>
        <audio-record v-else-if="!correction.audio" pause @audio="onCorrectionAudio"/>
      </b-card-body>
    </b-card>

    <!--    //Btn toolbar-->
    <back-btn-toolbar>
      <b-btn v-if="!text.fini && false" @click="submit">Envoyer</b-btn>
      <b-btn v-if="text.fini && !text.corrige && isTeacher()" @click="submitCorrection">Corriger</b-btn>
    </back-btn-toolbar>
  </div>

</template>

<script>
import BackBtnToolbar from "@/components/back-btn-toolbar";
import ExerciceDisplay from "@/components/ExercicesComponents/exerciceDisplay";
import AudioRecord from "@/components/audioRecord";
import {Auth, Storage, Textes} from "@/js/caller";

function blobToBase64(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      resolve(reader.result);
    };
  });
}

async function base64ToBlob(base64) {
  if (!base64) return null;
  const base64Response = await fetch(base64);
  return base64Response.blob();
}

export default {
  name      : "expressionOrale",
  components: {AudioRecord, ExerciceDisplay, BackBtnToolbar},
  props     : {
    text: {
      type: [Object],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      key  : "audioTrack",
      audio: null,
      // Correction Temp
      correction: {
        audio: null,
      }
    }
  },
  methods: {
    onAudio(blob) {
      this.audio = blob;
      this.saveLocalAudio();
    },
    removeAudio() {
      this.audio = null;
    },
    getURL() {
      return (typeof this.audio === "string") ? this.audio : window.URL.createObjectURL(this.audio);
    },
    async saveLocalAudio() {
      const {key, audio, text: {id}} = this
      const base64 = await blobToBase64(audio);
      Storage.Save(key, {id, base64});
    },
    async getLocalAudio() {
      const {key, text: {id}} = this;
      this.audio = await base64ToBlob(Storage.Get(key, id)?.base64)
    },
    async submit() {
      const {key, text, audio} = this;
      text.texte_original = audio;
      text.fini = 1;
      Textes.Save(text).then(
          () => {
            Storage.Remove(key, text.id)
            this.text = text;
          }
      )
    },
    isTeacher() {
      return Auth.IsTeacher();
    },
    //Correction
    onCorrectionAudio(blob) {
      this.correction.audio = blob;
      this.saveLocalCorrectionAudio();
    },
    removeCorrectionAudio() {
      this.correction.audio = null;
    },
    getCorrectionURL() {
      return (typeof this.correction.audio === "string") ? this.correction.audio : window.URL.createObjectURL(this.correction.audio);
    },
    async saveLocalCorrectionAudio() {
      const {key, correction: {audio}, text: {id}} = this
      const base64 = await blobToBase64(audio);
      Storage.Save(key, {id, base64});
    },
    async getLocalCorrectionAudio() {
      const {key, text: {id}} = this;
      this.correction.audio = await base64ToBlob(Storage.Get(key, id)?.base64)
    },
    async submitCorrection() {
      const {key, text, correction: {audio}} = this;
      text.texte_original = audio;
      text.corrige = 1;
      Textes.Correct(text).then(
          () => {
            Storage.Remove(key, text.id)
            this.text = text;
          }
      )
    },
  },
  created() {
    if (this.text.texte_original) this.audio = this.text.texte_original;
    else this.getLocalAudio();
    if (this.text.texte_corrige) this.correction.audio = this.text.texte_corrige;
    else this.getLocalCorrectionAudio();

  }
}
</script>

<style scoped>

</style>